/*global window:false*/
'use strict';

var ContentBundle = require('./ContentBundle');

exports.loadBundle = function loadBundle(bundleName, callback) {
    // the externalized content will already be resolved by target and locale
    var err;
    if (window.$i18n) {
        var rawBundle = window.$i18n[bundleName];
        if (rawBundle) {
            var bundle = new ContentBundle({
                rawBundle: rawBundle,
                bundleName: bundleName
            });
            if (callback) {
                return callback(null, bundle);
            }
            // for sync calls
            return bundle;
        } else {
            err = new Error('Bundle is not found: ' + bundleName);

        }
    } else {
        err = new Error('Bundles have not been registered');
    }

    if (callback) {
        return callback(err);
    } else {
        // for sync calls
        throw err;
    }

};
